/**
 * Fill color defaults to the color of the current text.
 * To change the fill color, apply a text color utility class
 * to the parent element or to the icon itself,
 * e.g. `className="text-blue-500"`
 */

const Inbox = ({ className = "" }) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={`group-hover:fill-white ${className}`} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.66675 7.66663H3.66675L5.66675 9.66663H8.33341L10.3334 7.66663H12.3334M1.66675 2.99996C1.66675 2.64634 1.80722 2.3072 2.05727 2.05715C2.30732 1.8071 2.64646 1.66663 3.00008 1.66663H11.0001C11.3537 1.66663 11.6928 1.8071 11.9429 2.05715C12.1929 2.3072 12.3334 2.64634 12.3334 2.99996V11C12.3334 11.3536 12.1929 11.6927 11.9429 11.9428C11.6928 12.1928 11.3537 12.3333 11.0001 12.3333H3.00008C2.64646 12.3333 2.30732 12.1928 2.05727 11.9428C1.80722 11.6927 1.66675 11.3536 1.66675 11V2.99996Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Inbox;
